import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store/store';
import App from './App.jsx';
import './index.css';
import registerServiceWorker from './pwa/registerServiceWorker';
import { setUpdateReady } from './pwa/useServiceWorkerUpdate';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);

// Registered after the first render is scheduled so the worker never competes
// with the app bundle for the connection on a cold start. No-op in dev builds.
registerServiceWorker({ onUpdateReady: setUpdateReady });
